<template>
  <div
    class="column flex-center"
    data-test-id="site-selector-popup"
  >
    <h2
      class="text-center text-primary q-mt-none"
    >
      {{ currentSite.displayName }}
    </h2>
    <q-card-section
      class="text-body q-px-sm q-py-none text-dark full-width"
      style="text-align: left;"
    >
      <div
        :class="useDarkMode ? 'text-white' : 'text-dark'"
      >
        {{ currentSite.address1 }}
      </div>
      <div
        class="q-mb-sm"
        :class="useDarkMode ? 'text-white' : 'text-dark'"
      >
        {{ currentSite.city }}, {{ currentSite.state }} {{ currentSite.zip }}
      </div>
      <q-btn
        class="q-mb-sm full-width"
        padding="sm"
        :label="$t('siteLocation.directions')"
        color="primary"
        :text-color="$isColorDark(currentSite.primaryColor) ? 'white' : 'black'"
        :type="isSiteDirectionsHrefInternal ? 'button' : 'a'"
        :href="isSiteDirectionsHrefInternal ? undefined : siteDirectionsHref"
        :to="isSiteDirectionsHrefInternal ? siteDirectionsHref : undefined"
      />
      <q-btn
        v-if="showChangeLocationButton"
        class="q-mb-sm full-width"
        padding="sm"
        color="secondary"
        :text-color="$isColorDark(currentSite.secondaryColor) ? 'white' : 'black'"
        :label="$t('siteLocation.actions.change')"
        @click="navigateToSiteSelect()"
      />
      <q-btn
        v-if="!currentSite.consumerConfig.hidePhone && currentSite.phone"
        v-ripple
        class="full-width"
        padding="sm"
        color="responsive"
        outline
        :label="$t('actions.call')"
        :href="sitePhoneHref"
      />
    </q-card-section>
  </div>
</template>

<script>
export default {
  name: 'SiteSelectorPopUp',
  configuration: [
    'currentSite'
  ],
  context: ['currentUser'],
  props: {
    useDarkMode: {
      type: Boolean,
      default: false
    },
    showChangeLocationButton: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  emits: ['show-site-selector-drawer', 'dismiss-site-selector'],
  computed: {
    sitePhoneHref () {
      return `tel: + ${this.currentSite.phone}`
    },
    siteDirectionsHref () {
      const destination = encodeURI(`${this.currentSite.name} ${this.currentSite.address1} ${this.currentSite.city} ${this.currentSite.state} ${this.currentSite.zip}`)
      if (this.currentSite.consumerConfig.currentLocationDetailLinkUrl) {
        return this.$appendCurrentQueryParams(`${this.currentSite.consumerConfig.currentLocationDetailLinkUrl}?preferred`)
      } else {
        return `https://www.google.com/maps/dir/?api=1&destination=${destination}`
      }
    },
    isSiteDirectionsHrefInternal () {
      return _.startsWith(this.siteDirectionsHref, '/')
    }
  },
  methods: {
    navigateToSiteSelect () {
      this.$emit('show-site-selector-drawer')
      if (this.$q.screen.xs) {
        this.$emit('dismiss-site-selector')
      }
    }
  }
}
</script>
